<template>
  <div class="column">
    <div class="name">{{name}}</div>
    <div class="positions">{{positions}}</div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * @description ФИО сотрудника.
     * @type {string}
     */
    name: { required: true, type: String },
    /**
     * @description Должности сотрудника.
     * @type {string}
     */
    positions: { default: '', type: String },
  },
};
</script>

<style scoped>
.column {
  display: flex;
  gap: 10px;
  padding: 10px 0;
  width: 100%;
}
.row {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 3px;
  padding: 10px 0;
}
.name {
  font-size: 14px;
  line-height: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.positions {
  font-size: 12px;
  line-height: 14px;
}
@media screen and (max-width: 480px) {
  .name {
    font-size: 16px;
    line-height: 16px;
  }
  .positions {
    font-size: 16px;
    line-height: 16px;
  }
}
</style>
